<template>
  <v-container class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" lg="10">
        <v-card>
          <v-toolbar color="light-green darken-1" dark flat>
            <v-toolbar-title>Roboter bearbeiten</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form
              name="formroboter"
              @submit.prevent="save"
              v-model="formValid"
            >
              <v-container>
                <v-row class="pa-0 ma-0">
                  <v-col cols="12" sm="6">
                    <v-switch
                      color="green"
                      v-model="roboter.active"
                      label="Roboter aktiv"
                    />
                  </v-col>
                </v-row>
                <v-row class="pa-0 ma-0" justify-center align-center>
                  <v-col cols="12" sm="10">
                    <v-text-field
                      label="Roboter ID"
                      name="rid"
                      type="text"
                      color="purple"
                      hint="Diese Roboter ID muss direkt beim Roboter für Anfragen gespeichert werden."
                      persistent-hint
                      v-model="roboter._id"
                      disabled
                    />
                  </v-col>
                  <v-col>
                    <v-btn @click="copyId" icon color="secondary"
                      ><v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row class="pa-0 ma-0">
                  <v-col cols="12" sm="12">
                    <v-text-field
                      label="Roboter Name"
                      name="name"
                      type="text"
                      color="purple"
                      :rules="requiredRule"
                      :clearable="true"
                      v-model="roboter.name"
                    />
                  </v-col>
                </v-row>
                <v-row class="pa-0 ma-0">
                  <v-col cols="12" sm="12">
                    <v-text-field
                      label="Roboter Standort"
                      name="standort"
                      type="text"
                      color="purple"
                      :rules="requiredRule"
                      :clearable="true"
                      v-model="roboter.standort"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <CustomerSelectbox
                      v-model="customer"
                      :rules="requiredRule"
                    />
                  </v-col>
                </v-row>
                <h3>Service Codes</h3>
                <v-row>
                  <v-col>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Name</th>
                            <th class="text-left">Code</th>
                            <th class="text-left">QR Code</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in roboter.serviceCodes"
                            :key="index"
                          >
                            <td>
                              {{ item.name }}
                            </td>
                            <td>{{ item.code }}</td>
                            <td>
                              <v-img
                                v-show="item.qrCode"
                                :src="item.qrCode"
                                width="48px"
                                height="48px"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :to="{ path: '/robots' }"
              color="error"
              type="button"
              name="cancel"
              >Abbrechen</v-btn
            >
            <v-spacer />
            <v-btn
              @click="save"
              color="success"
              name="submit"
              type="submit"
              :disabled="!formValid"
              >Speichern</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CustomerSelectbox from "@/components/customers/CustomerSelectbox";

export default {
  name: "UserForm",
  components: { CustomerSelectbox },
  props: [],
  data: () => ({
    requiredRule: [value => !!value || "Dieses Feld wird benötigt!"],
    formValid: false,
    customer: null
  }),
  computed: {
    roboter: {
      get() {
        return this.$store.getters["roboter/getRoboter"];
      },
      set(value) {
        this.$store.commit("roboter/SET_ROBOTER", value);
      }
    }
  },
  methods: {
    copyId() {
      if (this.roboter._id) {
        navigator.clipboard.writeText(this.roboter._id);
        this.$notify({
          group: "dataline",
          type: "info",
          title: "Roboter ID",
          text: "Roboter ID kopiert"
        });
      } else {
        this.$notify({
          group: "dataline",
          type: "warn",
          title: "Roboter ID",
          text: "Keine Roboter ID vorhanden"
        });
      }
    },

    save() {
      this.roboter.ownerCustomer = this.customer._id;

      this.$store
        .dispatch("roboter/saveRoboter")
        .then(() => {
          //if success redirect to list
          this.$router.push({ name: "robots" });
          this.$notify({
            group: "dataline",
            type: "success",
            title: "Roboter gespeichert",
            text: "Roboter erfolgreich gespeichert"
          });
        })
        .catch(error => {
          //on error alert error
          console.log(error);
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: error.message
          });
        });
    }
  },
  created() {
    const id = this.$route.params.id;

    if (id) {
      this.$store
        .dispatch("roboter/fetchRoboter", id)
        .then(async () => {
          let customers = this.$store.getters["customer/getCustomerList"];

          if (customers && customers.length == 0) {
            try {
              customers = await this.$store.dispatch(
                "customer/fetchCustomerList"
              );
            } catch (error) {
              Promise.reject(new Error("Error loading customers"));
            }
          }

          this.customer = customers.find(
            el => el._id === this.roboter.ownerCustomer
          );
        })

        .catch(error => {
          console.log(error);
          if (error && error.response && error.response.status != 401) {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler",
              text: error.message
            });
          }
        });
    } else {
      this.$store.commit("SET_APP_LOADING", true);
      this.$store.dispatch("roboter/createRoboterIDs").finally(() => {
        this.$store.commit("SET_APP_LOADING", false);
      });
    }
  }
};
</script>

<style scoped></style>
